module.exports = __webpack_public_path__ + "img/instagram.63bcf354.png";